import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

interface ModalContextValue {
  open: (modal: Modal) => void;
  close: () => void;
}

const initialValue: ModalContextValue = {
  open: () => {},
  close: () => {},
};

const ModalContext = createContext<ModalContextValue>(initialValue);

type Modal = {
  element: React.ReactNode;
  options?: ModalOptions;
};

interface ModalOptions {}

export const useModal = () => useContext(ModalContext);

export function ModalProvider({ children }: { children: React.ReactNode }) {
  const [modal, setModal] = useState<Modal | null>(null);

  const open: ModalContextValue['open'] = useCallback((modal) => {
    setModal(modal);
  }, []);

  const close: ModalContextValue['close'] = useCallback(() => {
    setModal(null);
  }, []);

  const value = useMemo(() => ({ open, close }), [open, close]);

  return (
    <ModalContext.Provider value={value}>
      {children}

      {!!modal && modal.element}
    </ModalContext.Provider>
  );
}
